import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";
import {InputText} from "primereact/inputtext";
import TabViewPresval from "../../components/tabView";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";

const CustodiaBBVAView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TitlePage title='Mantenimientos / Custodia BBVA'/>
                    </Grid>
                    <Grid item xs={12}>
                        <TabViewPresval modelOptions={props.tabItems}
                                        activeIndex={props.activeIndex}
                                        onSelect={props.handleTabChange}/>
                    </Grid>
                    <Grid item xs={12}>
                        {props.activeIndex === 0 &&
                            <div className="p-grid">
                                <div className="p-col-12" style={{textAlign: "right"}}>
                                    <Button label="Guardar" onClick={props.openConfMsgSave}
                                            disabled={props.isDisabledData}/> &nbsp;&nbsp;
                                    <Button label="Desbloquear" onClick={props.openConfMsgEnabled}
                                            className="p-button-secondary"/> &nbsp;&nbsp;
                                    <Button label="Restaurar Datos" onClick={props.restartData}
                                            className="p-button-secondary"
                                            disabled={props.isDisabledData}/>
                                </div>
                                <div className="p-col-6">
                                    <SubtitleLabel header="Usuario" isBold={true}/>
                                    <InputText name="username" placeholder="Ex: Usuario 1"
                                               keyfilter={/^[0-9 A-Z a-z]*$/}
                                               maxLength={20}
                                               onChange={props.onChangeData}
                                               value={props.username} tabIndex={1}
                                               disabled={props.isDisabledData}
                                    />
                                </div>
                                <div className="p-col-6"/>
                                <div className="p-col-6">
                                    <SubtitleLabel header="Contraseña" isBold={true}/>
                                    <InputText name="password" placeholder="Ex: contra1"
                                               maxLength={20}
                                               onChange={props.onChangeData}
                                               value={props.password} tabIndex={2}
                                               disabled={props.isDisabledData}
                                    />
                                </div>
                                <div className="p-col-6"/>
                                <div className="p-col-6">
                                    <SubtitleLabel header="Cliente" isBold={true}/>
                                    <InputText name="trustClient" placeholder="Cliente"
                                               keyfilter={/^[0-9 A-Z a-z]*$/}
                                               maxLength={20}
                                               onChange={props.onChangeData}
                                               value={props.trustClient} tabIndex={2}
                                               disabled={props.isDisabledData}
                                    />
                                </div>
                                <div className="p-col-6"/>
                                <div className="p-col-6">
                                    <SubtitleLabel header="Dominio" isBold={true}/>
                                    <InputText name="baseUrl" placeholder="Ex: http://www.domain.com"
                                               maxLength={100}
                                               onChange={props.onChangeData}
                                               value={props.baseUrl} tabIndex={2}
                                               disabled={props.isDisabledData}
                                    />
                                </div>
                                <div className="p-col-6"/>
                                {props.confMsgEnabled}
                            </div>

                        }{props.activeIndex === 1 &&
                            <div className="p-grid">
                                <div className="p-col-12" style={{textAlign: "right"}}>
                                    <Button label="Guardar" onClick={props.openConfMsgSaveInst}/>
                                </div>

                                <div className="p-col-8">
                                    <DataTable value={props.dataInstitutions}
                                               responsive={true}
                                               resizableColumns={true}
                                               columnResizeMode={"fit"}>
                                        <Column style={{width: '10%', textAlign: 'center'}} field="automatic"
                                                header={"Automático"}
                                                body={props.automaticTemplate}/>
                                        <Column field="institutionName" header="Institución"
                                                style={{textAlign: 'left'}}
                                                sortable={true}/>
                                    </DataTable>
                                    <div className="p-col-4"/>
                                </div>
                            </div>
                        }
                        {props.confMsgSave}
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default (CustodiaBBVAView);